import styled, { css } from 'styled-components';

import { Flex } from '@/components/Flex';

export const FiltersCounter = styled(Flex)`
  border-radius: 50%;
  height: 17px;
  aspect-ratio: 1;
  place-content: center;
  align-items: center;
  align-self: center;

  ${({ theme }) => css`
    font-weight: ${theme.fontWeights.bold};
    font-size: ${theme.fontSizes.p3};
    background-color: ${theme.colors.primary};
  `}
`;
